import axios from "axios";
import Config from "../../Config";

class PromoService {
  getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
      },
    };
  }

  async getAllPromos(page = 1, perPage = 15, search = "", sortOrder = "desc", dateFrom = "", dateTo = "") {
    try {
      const params = new URLSearchParams({
        page: String(page),
        per_page: String(perPage),
        ...(search && { search: search.trim() }),
        ...(sortOrder && { sort_order: sortOrder }),
        ...(dateFrom && { date_from: dateFrom }),
        ...(dateTo && { date_to: dateTo }),
      });
      const response = await axios.get(
        `${Config.promoApiBase}/all_promos?${params}`,
        this.getHeaders()
      );
      const resData = response.data?.data;
      if (resData?.status_code === "000" && resData?.data) {
        return {
          status: true,
          data: resData.data.data || [],
          pagination: resData.data.pagination || {},
          message: resData.reason || "Promo submissions fetched successfully",
        };
      }
      return {
        status: false,
        data: [],
        pagination: {},
        message: resData?.reason || resData?.message || "Failed to fetch promo submissions",
      };
    } catch (error) {
      return {
        status: false,
        data: [],
        pagination: {},
        message:
          error.response?.data?.data?.reason ||
          error.response?.data?.message ||
          "Something went wrong",
      };
    }
  }
}

export default new PromoService();
